


































import { Component, Vue, Watch } from 'vue-property-decorator';
import PropertySelector from '@/components/PropertySelector.vue';
import TagSelector from '@/components/TagSelector.vue';

@Component({
    components: {
        PropertySelector,
        TagSelector
    },
})
export default class Home extends Vue {

    private formData!: string;
    private formObj: any = {};
    private selectedTags: string = '';
    private selectedProperties: string = '';
    private tagTextValue: string = '';
    private propsTextValue: string = '';

    @Watch('selectedTags', { immediate: true })
    private onTagChange(val: any) {
        console.log('Tags Changed', val);
        this.formObj.tags = val;
        this.formData = JSON.stringify(this.formObj);
    }

    @Watch('selectedProperties', { immediate: true })
    private onPropertyChange(val: any) {
        console.log('Properties Changed', val);
        this.formObj.property = val;
        this.formData = JSON.stringify(this.formObj);
    }

    private setTags() {
        this.selectedTags = this.tagTextValue;
    }

    private setProps() {
        this.selectedProperties = this.propsTextValue;
    }

}
